module.exports = __webpack_public_path__ + "img/图1-29斜度的标注及画法.9f2f326b.png";